<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.5 20.5V9.25002L12 3.60577L19.5 9.25002V20.5H13.9038V13.8078H10.0963V20.5H4.5Z" fill="currentColor"/>
</svg>
